import dayjs from 'dayjs';
import { getTextFromHtml, useLocalStorage } from '@marqvision/shared';
import { useReleaseNoteListQuery } from '~/apis/releaseNote';
import { ReleaseReleaseNoteProtocolsGetListResponse } from '~/swagger/data-contracts';

export const useViewModel = () => {
  const [readIdListStorage, setReadIdListStorage] = useLocalStorage<string>('release-note-read-id-list', '');
  const { isLoading, data } = useReleaseNoteListQuery({ select: parseList });

  const readIdList = readIdListStorage.split(',').map(Number);
  const list = data || [];
  const isEmpty = !isLoading && !list.length;

  const checkRead = (id: number) => readIdList.includes(id);

  const read = (id: number) => {
    setReadIdListStorage((prev) => {
      const list = prev.split(',').map(Number);
      if (!list.includes(id)) {
        list.push(id);
      }
      return list.join(',');
    });
  };

  return {
    isLoading,
    isEmpty,
    list,
    listItemProps: {
      read: {
        check: checkRead,
        action: read,
      },
    },
  };
};

export type UseViewModel = ReturnType<typeof useViewModel>;

const parseList = (data: ReleaseReleaseNoteProtocolsGetListResponse) => {
  return data.list
    .map((item) => ({
      date: dayjs(item.date).format('MMM D, YYYY'),
      isNew: item.is_new,
      list: item.popup_list
        .filter((note) => note.title)
        .map((note) => ({
          id: note.id,
          title: note.title || '',
          content: note.content ? getTextFromHtml(note.content) : '',
          imageUrl: note.thumbnail_url || undefined,
        })),
    }))
    .filter((item) => item.list.length);
};
